import React from "react";

import * as Styled from "./styles";

interface IUserModuleListProps {
  modules: string[];
}

const UserModuleList: React.FC<IUserModuleListProps> = ({ modules }) => (
  <Styled.Container>
    {modules.map((module) => (
      <span key={module}>{module.toUpperCase()}</span>
    ))}
  </Styled.Container>
);

export default UserModuleList;